import { render } from "./ServicePorts.vue?vue&type=template&id=5479cad4&scoped=true"
import script from "./ServicePorts.vue?vue&type=script&lang=js"
export * from "./ServicePorts.vue?vue&type=script&lang=js"

import "./ServicePorts.vue?vue&type=style&index=0&id=5479cad4&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5479cad4"]])

export default __exports__